import VueRouter from "vue-router";
import Vue from "vue";
import auth from "../firebase/auth";
import store from "../store";
import requestRoutes from "./requests";

const loadView = view => {
   return () => import(/* webpackChunkName: "view-[request]" */ `../components/pages/${view}/Index.vue`)
}
const loadLODash = () => {
   return () => import(/* webpackChunkName: "view-[request]" */ '../components/pages/Loan-Officers/Dashboard.vue')
}
const loadLO = () => {
   return () => import(/* webpackChunkName: "view-[request]" */ '../components/pages/Loan-Officers/Lender.vue')
}

Vue.use(VueRouter);

const router = new VueRouter({
   mode: "history",
   scrollBehavior(to, from, savedPosition) {
      // currently non-functioning due to fixed position of header and overflow: scroll
      if (savedPosition) {
         return savedPosition;
      } else {
         return { x: 0, y: 0 }
      }
   },
   routes: [
      {
         path: '/login',
         name: "login",
         component: loadView('Login')
      },
      {
         path: "/",
         name: "home",
         component: loadView('Home')
      },
      {
         path: "/users",
         name: "users",
         component: loadView('Users'),
         beforeEnter: (to, from, next) => {
            if (!store.state.user.isAdmin) {
               return next("/");
            }
            return next();
         }
      },
      {
         path: "/information",
         name: "information",
         component: loadView('Information')
      },
      {
         path: "/loan-officers",
         name: "loan-officers",
         component: loadLODash(),
         beforeEnter: (to, from, next) => {
            store.dispatch("loanOfficers/startUnsetActive");
            return next();
         }
      },
      {
         path: "/loan-officers/:id",
         name: "loan-officer-ind",
         component: loadLO(),
         beforeEnter: async (to, from, next) => {
            try {
               await store.dispatch("loanOfficers/startSetActive", to.params.id);
               return next();
            } catch (err) {
               return next("/loan-officers");
            }
         }
      },
      {
         path: "/services",
         name: "services",
         component: loadView('Services')
      },
      {
         path: "/licenses",
         name: "licenses",
         component: loadView('Licenses')
      },
      ...requestRoutes,
      {
         path: "*",
         component: loadView('NotFound')
      }
   ]
});

//limiting access to routes based on auth status
router.beforeEach(async (to, from, next) => {
   const user = await auth.checkUser();

   if (user) {
      try {
         if (!store.state.user.token) await store.dispatch("createUser", user);
      } catch (err) {
         await store.dispatch("logOut");
      }
      if (!store.state.services.services) await store.dispatch("startSetServices");
      if (!store.state.licenses.licenses) await store.dispatch("startSetLicenses");
      if (!store.state.optOut.requests) await store.dispatch("optOut/startSetRequests");
      if (!store.state.deleteReq.requests) await store.dispatch("deleteReq/startSetRequests");
      if (!store.state.knowReq.requests) await store.dispatch("knowReq/startSetRequests");
      if (!store.state.loanOfficers.loanOfficers) await store.dispatch("loanOfficers/startSetLoanOfficers");
      if (!store.state.loanOfficers.locations) await store.dispatch("loanOfficers/startSetLocations");
      if (!store.state.users.users && store.state.user.isAdmin) await store.dispatch("startSetUsers");
      if (store.state.user.loggingIn) store.dispatch("startSetLoggingIn", false);
   }
   // closing off some routes based on logged in state
   if (to.name !== "login" && !user) {
      next("/login");
   } else {
      next();
   }
   if (to.name === "login" && user) {
      next("/");
   } else {
      next();
   }
});

export default router;